module.exports = __webpack_public_path__ + "static/media/400172_01.081da5c0.png";